export default __webpack_public_path__ + "01d85e0a379862f03cf5d48caf7a12f9.svg";